import React from 'react'
import './CustomerService.css'

function CustomerService() {
  return (
    <div className='customerservice'>Welcome to Amazon Customer Service
    What would you like help with today? You can quickly take care of most things here, or connect with us when needed.
    .</div>
  )
}

export default CustomerService